import script from "./PaymentView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentView.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentView.vue?vue&type=style&index=0&id=76717715&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76717715"]])

export default __exports__